import {
  inValidRange,
  isValidCountryName,
  isValidLanguages,
  objComparison, validCanLeadToCert, validContentTypes,
  validFormats,
  validTimings
} from "../utils";

export const checkColumnStructure = (newTrainings, currentColumns) => {
  const currentColIds = Object.keys(currentColumns)
  newTrainings.forEach( newTraining => {
     if (!currentColIds.includes(newTraining.position)) return false
  })
  return true
}

export const checkTrainingsStructure = (items) => {
  const emptyItem = { id: "", name: "", organizer: "", description: "", link: "", language: [], duration: 0, type_format: "", country: "", timing: "", content_type: "", can_lead_to_certification: "", includes_exams_for_certification: "", price: 0, created: "", updated: "", position: "" }

  return items.every( item => objComparison(item, emptyItem))
}


export const addMissingTrainingKeys = (training) => {
  return {
    ...training,
    prerequisites: training.prerequisites || "",
    skills_group: training.skills_group || ""
  }
}

export const verifyTrainingValues = (training, maxSkillGroup) => {
  return {
      ...training,

      language: (isValidLanguages(training.language)) ? training.language : [],
      type_format: (validFormats.includes(training.type_format)) ? training.type_format : "",
      country: (isValidCountryName(training.country)) ? training.country : "",
      timing: (validTimings.includes(training.timing)) ? training.timing : "",
    //   Maybe do date validation
      content_type: (validContentTypes.includes(training.content_type)) ? training.content_type : "",
      can_lead_to_certification: (validCanLeadToCert.includes(training.can_lead_to_certification)) ? training.can_lead_to_certification : "",
      includes_exams_for_certification: ((training.includes_exams_for_certification === "Yes") || (training.includes_exams_for_certification === "No")) ? training.includes_exams_for_certification : "",
      skills_group: (inValidRange(training.skills_group, maxSkillGroup)) ? training.skills_group : [],
    }
}